export default __webpack_public_path__ + "static/media/principle-image.ea18a3f2.svg";